var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.labels.length)?_c('v-row',[_c('v-col',{attrs:{"cols":"3"}},[_c('h6',[_vm._v("Content excluded in this pretarget:")])]),_c('v-col',_vm._l((_vm.labels),function(item,i){return _c('h6',{key:i,staticClass:"text-caption"},[_vm._v(" "+_vm._s(item.label)+" ")])}),0)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }